import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { formatDate } from '../../utils/format';

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/roommates/matches').then(res => {
      setMatches(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const statusColors = {
    accepted: 'text-green-700 bg-green-50 border border-green-200',
    pending: 'text-[#9A7F00] bg-[#C8A800]/10',
    declined: 'text-red-600 bg-red-50 border border-red-200',
  };

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="w-8 h-8 border-2 border-[#C8A800] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!matches.length) {
    return (
      <div className="text-center py-20">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-8 h-8 text-[#DDDDDD] mb-3 mx-auto">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
        </svg>
        <p className="text-xl font-bold text-[#1B1B1B] mb-2">No matches yet</p>
        <p className="nav-link text-[#777777]">Start browsing the Discover tab to find roommates!</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {matches.map(match => (
        <div key={match.id} className="card p-4 flex items-center gap-4">
          {match.avatar_url ? (
            <img src={match.avatar_url} alt={match.match_name} className="w-12 h-12 rounded-full object-cover border border-[#C8A800]/30 flex-shrink-0" />
          ) : (
            <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold flex-shrink-0" style={{ backgroundColor: 'rgba(200,168,0,0.12)', color: '#C8A800' }}>
              {match.match_name?.[0]?.toUpperCase()}
            </div>
          )}

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <h3 className="font-semibold text-[#1B1B1B]">{match.match_name}</h3>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColors[match.status]}`}>
                {match.status}
              </span>
            </div>
            <p className="nav-link text-sm text-[#777777]">{match.major || 'No major listed'}</p>
            <p className="nav-link text-xs text-[#AAAAAA]">{formatDate(match.created_at)}</p>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="text-right">
              <div className="text-lg font-bold text-[#C8A800]">{match.compatibility_score}%</div>
              <div className="nav-link text-xs text-[#999999]">match</div>
            </div>
            {match.status === 'accepted' && match.conversation_id && (
              <button
                onClick={() => navigate(`/messages/${match.conversation_id}`)}
                className="btn-primary py-2 px-3 text-sm"
              >
                Chat
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
